<template>
  <div>
    <div v-loading="loading" v-if="status == 1">
      <div v-if="formJson" style="padding-left: 10%;padding-right: 10%;padding-top: 3%;">
        <v-form-render :form-json="formJson" :form-data="formData" :option-data="optionData" ref="vFormRef">
        </v-form-render>
        <div style="display: flex;justify-content: center;">
          <el-button type="primary" @click="submitForm" style="margin-bottom: 30px;">提交</el-button>
        </div>
      </div>
    </div>
    <div v-if="status == 2">
      <div style="padding-left: 10%;padding-right: 10%;padding-top: 3%;display: flex;justify-content: center;align-items: center;height: 100%;font-size: 18px;font-weight: bold;">
        您此次已填写完毕！
      </div>
    </div>
  </div>
</template>

<script>

  export default {
		name: "dcbg",
		data() {
			return {
				loading:false,
        status:1,
				sysKey:"",
				formJson: null,  
        formData: {},
        optionData : {}
			}
		},
		created() {
			this.getJson()
		},
		methods: {
      getJson(){
        let url = window.location.href;
        this.sysKey = url.split('?')[1];
        if(this.sysKey){
          this.loading = true;
          this.$axios.get("/wb_dcbg/getSys",{
                params: {
                  key: this.sysKey
                }
            }).then(res => {
              this.formJson = res.data.data ? JSON.parse(res.data.data.context) : null;
              this.loading = false
          })
        }
      },
			submitForm() {
        this.$refs.vFormRef.getFormData().then(formData => {
          this.loading = true
          var dates = {sysKey:this.sysKey,context:JSON.stringify(formData)}
          this.$axios.post("/wb_dcbg/save",dates).then(res => {
            this.$message({
              showClose: true,
              message: '反馈成功！',
              type: 'success'
            });
            this.loading = false
            this.status = 2
          })
        }).catch(error => {
          this.$message.error(error)
        })
			}
		}
	}
</script>